import * as React from 'react';

import { bemElement } from 'af-utils/bem.util';

import Dropdown from 'af-components/Controls/Dropdown';

import styles from './styles.module.scss';

interface DropdownOption {
	label: string;
	onClick: () => void;
}

interface OwnProps {
	label: string;
	id: number;
	isActive: boolean;
	onClick: (id: number) => void;
	renderLabel?: (id: number) => React.JSX.Element;
	resolveCustomClassName?: (active: boolean) => string;
	actionsOptions?: DropdownOption[];
}

type Props = OwnProps;

class Tab extends React.PureComponent<Props> {

	onTabClick = () => {
		const { onClick, id } = this.props;
		onClick(id);
	};

	render() {
		const { isActive, id, label, renderLabel, resolveCustomClassName, actionsOptions } = this.props;

		const className = !!resolveCustomClassName
			? resolveCustomClassName(isActive)
			: bemElement('tabs-navigation', 'tab', {
				active: isActive,
				actionDropdown: !!actionsOptions,
			});

		return (
			<div
				className={className}
				key={`${id}#${label}`}
				onClick={!isActive ? this.onTabClick : undefined}
			>
				<span className="tab-title">{renderLabel?.(id) ?? label}</span>
				{actionsOptions &&
					<div className={`${styles['font-normal']}`}>
						<Dropdown<DropdownOption>
							fixed={true}
							id="actions"
							isActionDropdown={true}
							labelKey="label"
							options={actionsOptions}
						/>
					</div>
				}
			</div>
		);
	}
}

export default Tab as React.ComponentClass<OwnProps>;
